/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { BeneficiaryAccount } from '~/types';
import axios, { ResponseType } from './axios';

export const getBeneficiaryAccounts = (
  beneficiaryId: string,
  params: any
): ResponseType<BeneficiaryAccount[]> => {
  return axios.get(`/beneficiaries/${beneficiaryId}/accounts`, { params });
};

export const createBeneficiaryAccount = (
  body: BeneficiaryAccount
): ResponseType<BeneficiaryAccount> => {
  return axios.post(`/beneficiaries/${body.beneficiaryId}/accounts`, body);
};

export const deleteBeneficiaryAccount = (beneficiaryId: string, id: string): ResponseType<void> => {
  return axios.delete(`/beneficiaries/${beneficiaryId}/accounts/${id}`);
};

export const editBeneficiaryAccount = (params: {
  beneficiaryId: string;
  id: string;
  body: BeneficiaryAccount;
}) => {
  return axios
    .put<BeneficiaryAccount>(
      `/beneficiaries/${params.beneficiaryId}/accounts/${params.id}`,
      params.body
    )
    .then((red) => red.data);
};
